const { actionCreators } = require("react/api/actions/modals");

App.Views.EventNotifications = {

    renderEventUrgent: function (eventTypeId, collection, update) {

        if (collection.size()) {

            let renderedDetailsUrgentHtml = "";
            const events = App.Objects.EventNotifications;
            var eventUrgentContainerByType = $(`#lista_eventos_urgentes_${eventTypeId}`);
            var prefixSelector = '#event_urgent_';

            collection.models.forEach(({ attributes: event }) => {
              const { id, messageBody } = event;
              const date  = Monet.Format.DateTime.formatToLocale(event.timeValuedTrue);
              renderedDetailsUrgentHtml += `
                <div id="event_urgent_${id}" class="eventItem event_id_${id}">
                  <div class="eventDescription">${messageBody}</div>
                  <div class="eventDate">${date}</div>
                </div>
              `;
            });

            if (update) {
                if (!Monet.Session.Maps.eventLogSort || Monet.Session.Maps.eventLogSort === 'DESC') {
                    eventUrgentContainerByType.prepend(renderedDetailsUrgentHtml);
                } else {
                    eventUrgentContainerByType.append(renderedDetailsUrgentHtml);
                }
            } else {
                eventUrgentContainerByType.html(renderedDetailsUrgentHtml);
            }

            eventUrgentContainerByType.find('.eventItem').each(function() {
                const arrayId = this.id.split('_');
                const indexId = arrayId.length - 1;
                const eventId = arrayId[indexId];

                $(this).off('click');
                $(this).on('click', () => {
                  window.globalStore.dispatch(actionCreators.openModal({
                    modalKey: 'eventDetails',
                    title: Monet.I18n.getResourcesByKey('eventDetails.modal.title'),
                    data: {
                      eventLogId: eventId
                    }
                  }));
                });
            });

            collection.models.forEach(({ attributes: event }) => {
              const tooltip = {
                elementId: event.id,
                selector: prefixSelector + event.id,
                my: 'left top',
                at: 'center right',
                solo: true,
                eventToShow: false,
                viewport: $("#Maps"),
                container: $("#Maps"),
                width: 480,
                hide: () => {
                    eventLog.releaseEventLog();
                    eventWindow.eventLogDiv && eventWindow.eventLogDiv.remove();
                }
              };
              Monet.Tooltip.addTooltip(tooltip);
            });

            Monet.Session.Maps = Monet.Session.Maps || {};
            Monet.Session.Maps.eventUrgentLastEventDate = null;

            events.setUrgentEventLogLastEventDate(collection);

        }

    },

    routeTemplateEventUrgent: function (data) {
        return new Monet.UI.LayoutGenerator({
            "tag": "div",
            "items": [
                {
                    "items": [
                        {
                            "items": [
                                {
                                    "html": data.total,
                                    "attributes": {
                                        "id": "totalEventsUrgents",
                                        "class": "qtd_item_urgent"
                                    }
                                },
                                {
                                    "items": [
                                        {
                                            "html": data.eventosUrgent.description,
                                            "attributes": {
                                                "class": "txt_event_urgent"
                                            }
                                        }
                                    ],
                                    "attributes": {
                                        "class": "eventDate"
                                    }
                                }
                            ],
                            "attributes": {
                                "id": "eventItemUrgent_" + data.eventosUrgent.id,
                                "class": "eventTypeDetail"
                            }
                        },
                        {
                            "attributes": {
                                "id": "lista_eventos_urgentes_" + data.eventosUrgent.id,
                                "class": "lista_eventos_urgentes"
                            }
                        }
                    ],
                    "attributes": {
                        "class": "eventItemUrgent"
                    }
                }
            ]
        }).render().innerHTML;
    },

    processInformationEventsUrgentList: function (arrayDetailsEventsUrgent, update) {

        var eventType = arrayDetailsEventsUrgent.eventType;
        var eventLogsLength = arrayDetailsEventsUrgent.totalEventLogs;
        var eventLogRouter = App.Objects.EventNotifications;

        var renderEventUrgentContainer = function () {

            var renderedUrgentHTML = "";

            renderedUrgentHTML += App.Views.EventNotifications.routeTemplateEventUrgent({
                eventosUrgent: eventType,
                total: eventLogsLength
            });

            $("#conteinerEventUrgent").append(renderedUrgentHTML);

            $("#eventItemUrgent_" + eventType.id).on("click", function () {

                var hideTooltipAndUrgentEventListDisplayed = function () {

                    if (Monet.Session.WindowNotification.selector) {

                        Monet.Tooltip.hideTooltip(Monet.Session.WindowNotification.selector);

                    }

                    Monet.Session.UrgentEventList.selector = null;
                    $("#lista_eventos_urgentes_" + eventType.id).hide();

                };

                var hideUrgentEventListDisplayed = function () {

                    if (Monet.Session.UrgentEventList.selector) {

                        if (Monet.Session.WindowNotification.selector) {

                            Monet.Tooltip.hideTooltip(Monet.Session.WindowNotification.selector);

                        }

                        $(Monet.Session.UrgentEventList.selector).hide();
                    }

                };

                var appendLoading = function () {

                    var loading = document.createElement('div');
                    var iconImg = document.createElement('img');

                    loading.setAttribute("class", "loadingPopupFormContainer");
                    iconImg.src = require("static/images/general/loading_blue.svg");
                    loading.appendChild(iconImg);

                    return loading;
                };

                if ($("#lista_eventos_urgentes_" + eventType.id).is(":visible")) {

                    hideTooltipAndUrgentEventListDisplayed();

                } else {

                    hideUrgentEventListDisplayed();

                    Monet.Session.UrgentEventList.selector = "#lista_eventos_urgentes_" + eventType.id;

                    $(Monet.Session.UrgentEventList.selector).html(appendLoading());
                    $(Monet.Session.UrgentEventList.selector).show();

                    eventLogRouter.getEventUrgentsByEventType(eventType.id);

                }

            });

            if ($(".detailErrorException").attr("visible") !== "true") {

                $(".detailErrorException").show();
                $(".detailErrorException").attr("visible", "true");
                $("#lista_eventos_urgentes_" + eventType.id).css('display', 'none');

            }

            //controla a exibição da lista pra que ela num ultrapasse a tela
            var p = $("#eventItemUrgent_" + eventType.id).position();

            if (p) {
                var total = p.left + $("#lista_eventos_urgentes_" + eventType.id).width();

                if (total > $(window).width()) {

                    var ponto = p.left + $("#eventItemUrgent_" + eventType.id).width();
                    var c = ponto - ($("#lista_eventos_urgentes_" + eventType.id).width() + 25);

                    $("#lista_eventos_urgentes_" + eventType.id).attr("style", "left: " + c + "px");
                }
            }

            App.MakeLayouts.screenConfigurationFunctions();
        };

        if (eventLogsLength && !update) {

            renderEventUrgentContainer();

        } else if (eventLogsLength && update) {

            var containerEventUrgent = document.querySelector("#eventItemUrgent_" + eventType.id);

            if (containerEventUrgent) {

                var totalEventUrgentHTML = containerEventUrgent.querySelector('.qtd_item_urgent');
                var listUrgentEventLog = containerEventUrgent.querySelector("#lista_eventos_urgentes_" + eventType.id);

                if (totalEventUrgentHTML) {
                    totalEventUrgentHTML.innerHTML = eventLogsLength;
                }

                if (listUrgentEventLog && listUrgentEventLog.style.display === 'block' && Monet.Session.UrgentEventList.canUpdate) {
                    eventLogRouter.getEventUrgentsByEventType(eventType.id, update);
                }

            } else {
                renderEventUrgentContainer();
            }

        } else {
            //se não vier eventLogs para o grupo
            //ele remove
            if ($("#eventItemUrgent_" + eventType.id).length > 0) {
                $(".eventItemUrgent #eventItemUrgent_" + eventType.id).parent().remove();
                $("#lista_eventos_urgentes_" + eventType.id).remove();
            }
        }

    }

};
